import ModuleAssets from 'features/submissions/components/organisms/ModuleAssets/ModuleAssets';

export default ModuleAssets;
